<script setup lang="ts">
import type { MenuItem } from '@/types/user'

import { type PropType } from 'vue'
import RecursiveMenu from './RecursiveMenu.vue'

defineProps({
  menuData: { type: Array as PropType<MenuItem[]>, require: true }
})

/* 菜单 path 直接使用 router/index.ts 中的完整路径 (如 /dashboard, /gateway/list),
 * 不再加任何前缀。DB 中 sys_menu.path 字段必须与静态路由 path 完全一致。 */
const menuIndex = (path: string) => path
</script>
<template>
  <template v-for="menuItem in menuData" :key="menuItem.menuId">
    <!-- 有子级菜单的时候  el-sub-menu-->
    <el-sub-menu :index="menuIndex(menuItem.path)" v-if="menuItem.children && menuItem.children.length > 0">
      <template #title>
        <el-icon>
          <component :is="menuItem.icon"></component>
        </el-icon>
        <span>{{ menuItem.title }}</span>
      </template>
      <RecursiveMenu :menuData="menuItem.children" />
    </el-sub-menu>
    <!-- 没有子级菜单的时候  el-menu-item -->
    <el-menu-item v-else :index="menuIndex(menuItem.path)">
      <el-icon>
        <component :is="menuItem.icon"></component>
      </el-icon>
      <span>{{ menuItem.title }}</span>
    </el-menu-item>
  </template>
</template>
<style scoped lang="scss"></style>
